import { type CurrencyName } from '@webapp/core/entities/external/Currency'
import { useSpendingCardRegion } from '@webapp/modules/spending-cards/hooks/useSpendingCardRegion'
import { useVirtualCardPaymentDetailsPresenter } from './useVirtualCardPaymentDetailsPresenter'
import { PaymentDetailsCard } from '../../views/PaymentDetailsCard'

export interface IVirtualCardPaymentDetailsPresenterProps {
  externalId: string
  last4Digits: string
  balance: string
  currency: CurrencyName
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
}

export const VirtualCardPaymentDetailsPresenter = ({
  externalId,
  last4Digits,
  balance,
  currency,
  scaToken,
  onVerificationRequired,
}: IVirtualCardPaymentDetailsPresenterProps) => {
  const {
    data: { iframeUrl },
    commands: { revealPaymentDetails, hidePaymentDetails },
    states: { showLoader },
  } = useVirtualCardPaymentDetailsPresenter({
    externalId,
    scaToken,
    onVerificationRequired,
  })

  const { region } = useSpendingCardRegion()

  return (
    <PaymentDetailsCard
      balance={balance}
      currency={currency}
      last4Digits={last4Digits}
      iframeUrl={iframeUrl}
      onRevealPaymentDetails={revealPaymentDetails}
      onHidePaymentDetails={hidePaymentDetails}
      isLoading={showLoader}
      region={region}
    />
  )
}
